export default class Nav {
	constructor() {
		this.elements = {
			sections: document.querySelectorAll('[data-nav-item]'),
			navWrappers: document.querySelectorAll('[data-nav-links]'),
			mobileTrigger: document.querySelector('button.c-nav__trigger'),
			mobileModal: document.querySelector('[data-modal="nav"] > *'),
		};

		this.activeNavId = null;
		this.modalIsOpen = false;
		this.createObserver();
		this.eventListeners();
	}

	toggleModal() {
		const { mobileTrigger, mobileModal } = this.elements;
		this.modalIsOpen = !this.modalIsOpen;
		mobileTrigger.classList.toggle('active');
		mobileModal.classList.toggle('active');
	}

	eventListeners() {
		this.elements.mobileTrigger.addEventListener('click', this.toggleModal.bind(this));

		const mobileNav = Array.from(this.elements.navWrappers).find(e => e.dataset.navLinks === 'mobile');
		mobileNav.addEventListener('click', this.toggleModal.bind(this));
	}

	highlightActiveNav(navWrapper, id) {
		if (this.activeNavId) {
			const previouslyActiveLink = navWrapper.querySelector(`a[href="#${this.activeNavId}"]`).parentElement;
			previouslyActiveLink.classList.remove('active');
		}

		const activeLink = navWrapper.querySelector(`a[href="#${id}"]`).parentElement;
		activeLink.classList.add('active');
	}

	createObserver() {
		const { navWrappers, sections } = this.elements;
		this.observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					const { id } = entry.target;
					navWrappers.forEach(navWrapper => this.highlightActiveNav(navWrapper, id));
					this.activeNavId = id;
				}
			});
		});

		sections.forEach(section => this.observer.observe(section));
	}
}
